// @ts-strict-ignore
import React from "react";
import type { Components } from "react-markdown";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";

import TextLink from "components/parts/NextLink/TextLink";
import ContentfulTable from "../table/ContentfulTable";

interface MarkdownProps {
  source?: string;
  children?: string;
  config?: Components;
}

const Markdown: React.FunctionComponent<MarkdownProps> = ({
  source,
  config,
  children
}: MarkdownProps) => {
  return (
    <ReactMarkdown
      children={source || children}
      rehypePlugins={[rehypeRaw]}
      remarkPlugins={[remarkGfm]}
      components={{
        a: TextLink as any,
        table: ContentfulTable,
        img: ({ src, alt, ...props }) => {
          if (
            src?.endsWith(".mp4") ||
            src?.endsWith(".webm") ||
            src?.endsWith(".mov")
          ) {
            return (
              <video controls style={{ maxWidth: "100%", height: "auto" }}>
                <source
                  src={src.startsWith("//") ? `https:${src}` : src}
                  type="video/mp4"
                />
                {alt && <p>{alt}</p>}
              </video>
            );
          }
          return (
            <img
              src={src?.startsWith("//") ? `https:${src}` : src}
              alt={alt}
              {...props}
            />
          );
        },
        ...config
      }}
      linkTarget="_blank"
    />
  );
};

export default Markdown;
